// utils/currency.js

export const CURRENCY = {
  code: 'CAD',
  locale: 'en-CA',
  label: 'Canadian Dollar',
};

export const formatCurrency = (amount?: string | number | null) => {
  if (amount === undefined || amount === null) return '-';
  return new Intl.NumberFormat(CURRENCY.locale, {
    style: 'currency',
    currency: CURRENCY.code,
    currencyDisplay: 'code',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(amount));
};
